import SUBSCRIPTION_ACTION_TYPES from './subscription.types'
import { DIAPERS_BUNDLE } from '../../utils/bab/bab.utils'

const SUBSCRIPTION_INITIAL_STATE = {
  data: {
    bundle: DIAPERS_BUNDLE.id,
    frequency: 30,
    variants: {},
    upgrades: [],
    upsells: []
  },
  mix: false,
  navigation: {
    step: 1,
    sizeSubSteps: {
      total: 0,
      completed: 0
    },
    patternSubSteps: {
      total: 0,
      completed: 0
    }
  }
}

export const subscriptionReducer = (
  state = SUBSCRIPTION_INITIAL_STATE,
  action = {}
) => {
  const { type, payload } = action

  switch (type) {
    case SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_DATA:
      return {
        ...state,
        data: payload
      }
    case SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_BUNDLE:
      return {
        ...state,
        data: {
          ...state.data,
          bundle: payload
        }
      }
    case SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_FREQUENCY:
      return {
        ...state,
        data: {
          ...state.data,
          frequency: payload
        }
      }
    case SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_VARIANTS:
      return {
        ...state,
        data: {
          ...state.data,
          variants: payload
        }
      }
    case SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_PATTERNS:
      return {
        ...state,
        data: {
          ...state.data,
          variants: {
            ...state.data.variants,
            [payload.productSize]: payload.patternArray
          }
        }
      }
    case SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_UPSELLS:
      return {
        ...state,
        data: {
          ...state.data,
          upgrades: payload.subscriptionUpgrades,
          upsells: payload.subscriptionUpsells
        }
      }
    case SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_MIX:
      return {
        ...state,
        mix: payload
      }
    case SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_NAVIGATION:
      return {
        ...state,
        navigation: payload
      }
    case SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_STEP:
      return {
        ...state,
        navigation: {
          ...state.navigation,
          step: payload
        }
      }
    case SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_SIZE_SUBSTEPS:
      return {
        ...state,
        navigation: {
          ...state.navigation,
          sizeSubSteps: {
            total: payload.total,
            completed: payload.completed
          }
        }
      }
    case SUBSCRIPTION_ACTION_TYPES.SET_SUBSCRIPTION_PATTERN_SUBSTEPS:
      return {
        ...state,
        navigation: {
          ...state.navigation,
          patternSubSteps: {
            total: payload.total,
            completed: payload.completed
          }
        }
      }
    case SUBSCRIPTION_ACTION_TYPES.GO_TO_BUNDLE:
      return {
        ...state,
        navigation: {
          step: 0,
          sizeSubSteps: {
            total: 0,
            completed: 0
          },
          patternSubSteps: {
            total: 0,
            completed: 0
          }
        }
      }
    case SUBSCRIPTION_ACTION_TYPES.GO_TO_SIZE:
      return {
        ...state,
        navigation: {
          step: 1,
          sizeSubSteps: {
            total: 0,
            completed: 0
          },
          patternSubSteps: {
            total: 0,
            completed: 0
          }
        }
      }
    default:
      return state
  }
}
